import React, { useEffect, useState } from 'react'
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'


const FilterQuickSelect = props => {
    useStyles(classes)
    const {isShipping, changeSelect, intl, selected, data, defaultSelectionLabel} = props

    return (
        <div className={classes.FilterQuickSelect}>
            { isShipping && defaultSelectionLabel && <div className={`${classes.QuickPriceItem} ${selected == 'ship' ? classes.Selected: ''}`} onClick={() => changeSelect('ship')}>{defaultSelectionLabel}</div> }
            {
                data && data.length > 0 && data.map((item,index) => {
                    return <div className={`${classes.QuickPriceItem} ${selected == item.value ? classes.Selected: ''}`} onClick={() => changeSelect(item)}>{item.label}</div>
                })
            }
        </div>
    )
}

export default FilterQuickSelect